import React, { createContext, useContext } from "react";

import type { ClaimsContextValue } from "./types";

const ClaimsContext = createContext<ClaimsContextValue | null>(null);

export const ClaimsProvider = ({
  value,
  children,
}: {
  value: ClaimsContextValue;
  children: React.ReactNode;
}) => <ClaimsContext.Provider value={value}>{children}</ClaimsContext.Provider>;

export const useClaims = (): ClaimsContextValue => {
  const ctx = useContext(ClaimsContext);
  if (!ctx) {
    throw new Error("useClaims must be used within ClaimsProvider");
  }
  return ctx;
};

export type { ClaimsContextValue };
